export const textUtils = {
    equipment: {
        internet1200Modem: {
            standalone: "SERCOMM - DG4244S"
        },
        customerOwnedModem: {
            header: "CUSTOMER OWNED MODEM",
            message: "This is a Customer Owned Modem.Do not install or leave behind a WOW! Modem on this account."
        },
        eero: {
            make: "EEROS"
        },
        hit: {
            hitFailed: "Still processing previous hit request. Please wait 2 minutes before sending additional hits to this equipment.",
            hitAllFailed1: "Still processing previous hit request for equipment/s with serial number: ",
            hitAllFailed2: ". Please wait 2 minutes before sending additional hits to this equipment."
        }
    },
    security: {
        title: "Security",
        noOptionSelected: "none"
    },
    workOrder: {
        deliveryProofCheckbox: "Tech handed the self install kit directly to the customer.",
    }
};



// WEBPACK FOOTER //
// ./src/utils/textUtils.js